// Furniture data directly from JNN Homes STR checklist Google Sheet
export const furnitureData = {
  supplies: [
    {
      name: "Trash Bags (13 Gallon)",
      desc: "Heavy-duty kitchen trash bags",
      link: "https://amzn.to/4fEdsoY",
      qty: 2,
    },
    {
      name: "Washing Detergent",
      desc: "Laundry detergent pods/liquid",
      link: "https://amzn.to/4pV301e",
      qty: 2,
    },
    {
      name: "Dishwashing Pods",
      desc: "Automatic dishwasher pods",
      link: "https://amzn.to/4pOBLVW",
      qty: 2,
    },
    {
      name: "Hand Soap Refill",
      desc: "Bulk hand soap for sink dispensers",
      link: "https://amzn.to/3TymKvA",
      qty: 2,
    },
    {
      name: "Paper Towels",
      desc: "Multi-pack absorbent paper towels",
      link: "https://amzn.to/3RMg2Bp",
      qty: 3,
    },
    {
      name: "Toilet Paper",
      desc: "Bulk soft bathroom tissue rolls",
      link: "https://amzn.to/4bmppi6",
      qty: 3,
    },
    {
      name: "Bath Towels",
      desc: "Plush guest bath towels set",
      link: "https://amzn.to/4zcmgvB",
      qty: 3,
    },
    {
      name: "Grounded Coffee",
      desc: "Premium ground coffee for guests",
      link: "https://amzn.to/4bubAy6",
      qty: 3,
    },
    {
      name: "Coffee Filter",
      desc: "Standard coffee machine filters",
      link: "https://amzn.to/4wBjE8y",
      qty: 3,
    },
    {
      name: "Coffee Creamer",
      desc: "Single-serve coffee creamer cups",
      link: "https://amzn.to/4w5HKHD",
      qty: 2,
    },
    {
      name: "Sugar",
      desc: "Granulated sugar for coffee bar",
      link: "https://amzn.to/4hbeRWO",
      qty: 1,
    },
    {
      name: "Salt",
      desc: "Kitchen pantry staple salt",
      link: "https://amzn.to/4wMViss",
      qty: 1,
    },
  ],
  general: [
    {
      name: "Smart Lock (Front Door)",
      desc: "Keyless electronic entry lock",
      link: "https://amzn.to/4g8dqHp",
      qty: 1,
    },
    {
      name: "Hair Dryer",
      desc: "Compact ionic hair dryer",
      link: "https://amzn.to/4yTb46z",
      qty: 3,
    },
    {
      name: "Fire Extinguisher",
      desc: "Safety extinguisher for floors & kitchen",
      link: "https://amzn.to/4pYS1nG",
      qty: 3,
    },
    {
      name: "Iron",
      desc: "Professional steam clothes iron",
      link: "https://amzn.to/4w2wSKo",
      qty: 2,
    },
    {
      name: "Hangers",
      desc: "Non-slip velvet hangers set",
      link: "https://amzn.to/4qcHQfn",
      qty: 6,
    },
    {
      name: "Broom",
      desc: "Utility broom and dustpan set",
      link: "https://amzn.to/3TyDuTn",
      qty: 1,
    },
    {
      name: "Door Mat",
      desc: "Heavy-duty entrance mat",
      link: "https://amzn.to/4hKJDG2",
      qty: 2,
    },
    {
      name: "Iron Board",
      desc: "Foldable sturdy ironing board",
      link: "https://amzn.to/3RqJ89B",
      qty: 2,
    },
  ],
  kitchen: [
    {
      name: "Keurig Coffee Machine",
      desc: "Single-serve K-Cup coffee maker",
      link: "https://amzn.to/3S5pHmS",
      qty: 1,
    },
    {
      name: "Kitchen Drawer Organizer",
      desc: "Expandable silverware tray organizer",
      link: "https://amzn.to/4531voc",
      qty: 1,
    },
    {
      name: "Utensil Set",
      desc: "Heat-resistant silicone cooking utensils",
      link: "https://amzn.to/4xkLiqw",
      qty: 1,
    },
    {
      name: "Cookware Set",
      desc: "Non-stick pots and pans cookware",
      link: "https://amzn.to/45DnFNS",
      qty: 1,
    },
    {
      name: "Toaster",
      desc: "Wide-slot 2-slice toaster",
      link: "https://amzn.to/4550SdL",
      qty: 1,
    },
    {
      name: "Sponge Holder",
      desc: "Stainless steel sink caddy",
      link: "https://amzn.to/4bsdy1R",
      qty: 1,
    },
    {
      name: "Knife Set",
      desc: "Kitchen knife block set with sharpener",
      link: "https://amzn.to/3TyDGSB",
      qty: 1,
    },
    {
      name: "Kitchen Mat",
      desc: "Anti-fatigue standing floor mat",
      link: "https://amzn.to/3ROLYFs",
      qty: 1,
    },
    {
      name: "Soap Dispenser Set",
      desc: "Glass dish soap and hand soap pumps",
      link: "https://amzn.to/4yUXnnQ",
      qty: 1,
    },
    {
      name: "Kitchen Oven Mitt",
      desc: "Heat-resistant silicone oven mitts",
      link: "https://amzn.to/4yZWqea",
      qty: 1,
    },
    {
      name: "Kitchen Towels",
      desc: "Absorbent microfiber kitchen dish towels",
      link: "https://amzn.to/4xax7Ee",
      qty: 1,
    },
    {
      name: "Soup Bowl",
      desc: "Deep ceramic cereal/soup bowls set",
      link: "https://amzn.to/4bVXXru",
      qty: 3,
    },
    {
      name: "Large Serving Bowl",
      desc: "Ceramic salad & serving bowl",
      link: "https://amzn.to/4hMfMgl",
      qty: 2,
    },
    {
      name: "Serving Dishes",
      desc: "Platters for family-style dining",
      link: "https://amzn.to/4c1f3Er",
      qty: 2,
    },
    {
      name: "Silverware",
      desc: "Stainless steel flatware cutlery",
      link: "https://amzn.to/4fJvxnb",
      qty: 3,
    },
    {
      name: "Salad Dish",
      desc: "Medium ceramic salad/appetizer plates",
      link: "https://amzn.to/44YU6pU",
      qty: 3,
    },
    {
      name: "Large Plate",
      desc: "Dinner plates set for group dining",
      link: "https://amzn.to/4hLcWIw",
      qty: 3,
    },
    {
      name: "Spice Rack",
      desc: "Countertop rotating spice organizer",
      link: "https://amzn.to/4fC2amI",
      qty: 1,
    },
    {
      name: "Drinking Glasses",
      desc: "Clear glass tumblers for water/beverages",
      link: "https://amzn.to/4w9Oynz",
      qty: 3,
    },
    {
      name: "Coffee Mugs",
      desc: "Ceramic coffee cups set",
      link: "https://amzn.to/45HHB25",
      qty: 2,
    },
    {
      name: "Coffee Mat",
      desc: "Absorbent rubber coffee bar mat",
      link: "https://amzn.to/4bVY6Ly",
      qty: 1,
    },
    {
      name: "First Aid Kit",
      desc: "Wall-mountable emergency medical kit",
      link: "https://amzn.to/3U81cWG",
      qty: 1,
    },
    {
      name: "Liquid Dish Soap",
      desc: "Hand dishwashing soap",
      link: "https://amzn.to/3TAE575",
      qty: 1,
    },
    {
      name: "Sponges",
      desc: "Non-scratch dish scrubber sponges",
      link: "https://amzn.to/4pQ3Qfw",
      qty: 1,
    },
    {
      name: "Baking Pan Set",
      desc: "Non-stick cookie sheets & baking pans",
      link: "https://amzn.to/4yYnXN2",
      qty: 1,
    },
    {
      name: "Trash Can (13 Gallons)",
      desc: "Stainless steel step kitchen trash bin",
      link: "https://amzn.to/45HHG5T",
      qty: 1,
    },
    {
      name: "Measuring Cups and Spoon Set",
      desc: "Precision baking measuring tools",
      link: "https://amzn.to/3S9lNJG",
      qty: 1,
    },
    {
      name: "Chopping Boards",
      desc: "Color-coded kitchen cutting boards",
      link: "https://amzn.to/3SdDl7v",
      qty: 1,
    },
    {
      name: "Kitchen Scissors",
      desc: "Heavy-duty multi-purpose shears",
      link: "https://amzn.to/4wBsByV",
      qty: 1,
    },
    {
      name: "Paper Towels Holder",
      desc: "Countertop paper towel stand",
      link: "https://amzn.to/4haCcb5",
      qty: 1,
    },
    {
      name: "Coffee Pods",
      desc: "Keurig variety coffee pod pack",
      link: "https://amzn.to/4xfJbEc",
      qty: 2,
    },
    {
      name: "K-Cup Holder",
      desc: "Drawer pod carousel storage",
      link: "https://amzn.to/4fMaG0X",
      qty: 1,
    },
    {
      name: "Can Opener",
      desc: "Manual smooth-edge can opener",
      link: "https://amzn.to/4xhfToO",
      qty: 1,
    },
    {
      name: "Hot Water Kettle",
      desc: "Electric fast-boiling water kettle",
      link: "https://amzn.to/4xhfUJo",
      qty: 1,
    },
    {
      name: "Blender",
      desc: "High-speed smoothie & drink blender",
      link: "https://amzn.to/4fMaI95",
      qty: 1,
    },
    {
      name: "Oven Toaster",
      desc: "Countertop toaster oven",
      link: "https://amzn.to/4yTaTs9",
      qty: 1,
    },
    {
      name: "Coffee Maker",
      desc: "Standard 12-cup drip coffee machine",
      link: "https://amzn.to/4fyGGaa",
      qty: 1,
    },
    {
      name: "Salt and Pepper Set",
      desc: "Refillable tabletop spice shakers",
      link: "https://amzn.to/4q1gGYI",
      qty: 1,
    },
  ],
  livingRoom: [
    {
      name: "85-inch Smart TV",
      desc: "Ultra HD 4K screen for main living room",
      link: "https://amzn.to/3RqJH3d",
      qty: 1,
    },
    {
      name: "U-Shape Fabric Sectional",
      desc: "Spacious seating for large guest groups",
      link: "https://amzn.to/45BYxXS",
      qty: 1,
    },
    {
      name: "Leather U-Shape Sectional",
      desc: "Premium easy-clean leather sofa option",
      link: "https://amzn.to/4boHQTb",
      qty: 1,
    },
    {
      name: "U-Shape 14-Seat Sectional",
      desc: "Max-capacity group seating sectional",
      link: "https://amzn.to/3TuHXGM",
      qty: 1,
    },
    {
      name: "Luxury Wood Coffee Table",
      desc: "Center table with hidden storage drawer",
      link: "https://www.wayfair.com/furniture/pdp/latitude-run-luxury-wood-coffee-table-with-hidden-drawer-easy-installation-square-center-table-for-living-room-raised-edge-design-premium-walnut-finish-3937-square-coffee-table-w121101724.html?piid=992901082",
      qty: 1,
    },
    {
      name: "Machine Washable Rug (10x14)",
      desc: "Vintage lightweight large living area rug",
      link: "https://www.amazon.com/dp/B0DJS6XHN8",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Modern side table for sofa end",
      link: "https://amzn.to/4pVDJ78",
      qty: 1,
    },
    {
      name: "Sofa Pillow (Green)",
      desc: "Decorative accent throw pillow",
      link: "https://amzn.to/4brzN8h",
      qty: 1,
    },
    {
      name: "Sofa Pillow (Beige)",
      desc: "Neutral textured throw pillow",
      link: "https://amzn.to/4fMhjQV",
      qty: 1,
    },
    {
      name: "7FT Fake Tree",
      desc: "Large decorative artificial indoor plant",
      link: "https://amzn.to/3Rvpmd3",
      qty: 2,
    },
    {
      name: "Coffee Table Decor Tray",
      desc: "Wooden tray for books and remote controls",
      link: "https://amzn.to/4w55xr5",
      qty: 1,
    },
  ],
  extraLivingRoom: [
    {
      name: "L-Shape Sofa",
      desc: "Comfortable sectional sofa for secondary living space",
      link: "https://amzn.to/4pVE2ii",
      qty: 1,
    },
    {
      name: "Round Coffee Table",
      desc: "Modern circular living room center table",
      link: "https://amzn.to/4caPtgb",
      qty: 1,
    },
    {
      name: "Sofa Pillow (Beige)",
      desc: "Cozy accent pillow for secondary sofa",
      link: "https://amzn.to/4fMhjQV",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Side tables for secondary seating",
      link: "https://amzn.to/4g8ZH3a",
      qty: 2,
    },
    {
      name: "Lamp",
      desc: "Warm ambient reading lamp",
      link: "https://amzn.to/4g8cfrx",
      qty: 1,
    },
  ],
  diningRoom: [
    {
      name: "Dining Table",
      desc: "Large dining room table for group meals",
      link: "https://amzn.to/4h6GQ9Z",
      qty: 1,
    },
    {
      name: "8 Dining Chairs",
      desc: "Upholstered high-back dining chairs",
      link: "https://amzn.to/4hbt3is",
      qty: 1,
    },
    {
      name: "9x12 Rug",
      desc: "Stain-resistant rug for dining space",
      link: "https://amzn.to/4hbHB1C",
      qty: 1,
    },
    {
      name: "Decor Table",
      desc: "Entryway or dining side buffet table",
      link: "https://amzn.to/3TSfdrr",
      qty: 1,
    },
    {
      name: "40 Inches Round Mirror",
      desc: "Large decorative accent mirror",
      link: "https://amzn.to/4fOcQgG",
      qty: 1,
    },
  ],
  bedroom1: [
    {
      name: "King Size Bed Frame",
      desc: "Upholstered platform bed frame",
      link: "https://amzn.to/3SdFMqF",
      qty: 1,
    },
    {
      name: "King Mattress",
      desc: "Pressure-relieving supportive hybrid mattress",
      link: "https://amzn.to/4w3kYA4",
      qty: 1,
    },
    {
      name: "King Comforter",
      desc: "All-season plush bed insert",
      link: "https://amzn.to/4xh7WA3",
      qty: 1,
    },
    {
      name: "King Comforter Cover",
      desc: "Washable luxury duvet cover",
      link: "https://amzn.to/4wBmnyL",
      qty: 3,
    },
    {
      name: "Flat Sheet (King)",
      desc: "Breathable soft hotel sheet",
      link: "https://amzn.to/3RKKpZa",
      qty: 1,
    },
    {
      name: "Fitted Sheet (King)",
      desc: "Deep pocket mattress fitted sheet",
      link: "https://amzn.to/4fMLh7E",
      qty: 1,
    },
    {
      name: "Mattress Protector",
      desc: "Spill & stain protection cover",
      link: "https://amzn.to/3TSFxSi",
      qty: 1,
    },
    {
      name: "Pillow (King)",
      desc: "Ergonomic hotel bed sleeping pillows",
      link: "https://amzn.to/4fPSpjF",
      qty: 1,
    },
    {
      name: "Euro Shams (Olive Green)",
      desc: "Decorative bed backing pillow covers",
      link: "https://amzn.to/3ROPOyd",
      qty: 1,
    },
    {
      name: "Lumbar Accent Pillow (Beige)",
      desc: "Long decorative bed pillow",
      link: "https://a.co/d/0j51mQzQ",
      qty: 1,
    },
    {
      name: "Blanket (Olive Green)",
      desc: "Cozy accent blanket for foot of bed",
      link: "https://a.co/d/0cz8ZWOM",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Bedside drawer table",
      link: "https://amzn.to/4wwjkYF",
      qty: 1,
    },
    {
      name: "Lamp Set",
      desc: "Pair of nightstand touch lamps",
      link: "https://a.co/d/0bd30DjJ",
      qty: 1,
    },
    {
      name: "Art Work",
      desc: "Modern bedroom decor wall art",
      link: "https://amzn.to/4h6EZ4Y",
      qty: 1,
    },
    {
      name: "Samsung 50-inch Smart TV",
      desc: "UHD TV for guest bedroom entertainment",
      link: "https://amzn.to/4pV6vVq",
      qty: 1,
    },
    {
      name: "TV Mount Bracket",
      desc: "Full motion TV mount bracket",
      link: "https://amzn.to/4hchY0v",
      qty: 1,
    },
    {
      name: "6FT Faux Olive Tree",
      desc: "Decorative tall artificial tree",
      link: "https://amzn.to/4fOdlY6",
      qty: 1,
    },
    {
      name: "Bed Bench (Olive Green)",
      desc: "Upholstered seating bench",
      link: "https://amzn.to/4w6JJLN",
      qty: 1,
    },
    {
      name: "9x12 Area Rug",
      desc: "Soft floor area rug under bed",
      link: "https://a.co/d/0aBecZYJ",
      qty: 1,
    },
  ],
  bedroom2: [
    {
      name: "King Size Bed Frame",
      desc: "Upholstered platform bed frame",
      link: "https://amzn.to/3SdFMqF",
      qty: 1,
    },
    {
      name: "King Mattress",
      desc: "Pressure-relieving supportive hybrid mattress",
      link: "https://amzn.to/4w3kYA4",
      qty: 1,
    },
    {
      name: "King Comforter",
      desc: "All-season plush bed insert",
      link: "https://amzn.to/4xh7WA3",
      qty: 1,
    },
    {
      name: "King Comforter Cover",
      desc: "Washable luxury duvet cover",
      link: "https://amzn.to/4wBmnyL",
      qty: 3,
    },
    {
      name: "Flat Sheet (King)",
      desc: "Breathable soft hotel sheet",
      link: "https://amzn.to/3RKKpZa",
      qty: 1,
    },
    {
      name: "Fitted Sheet (King)",
      desc: "Deep pocket mattress fitted sheet",
      link: "https://amzn.to/4fMLh7E",
      qty: 1,
    },
    {
      name: "Mattress Protector",
      desc: "Spill & stain protection cover",
      link: "https://amzn.to/3TSFxSi",
      qty: 1,
    },
    {
      name: "Pillow (King)",
      desc: "Ergonomic hotel bed sleeping pillows",
      link: "https://amzn.to/4fPSpjF",
      qty: 1,
    },
    {
      name: "Euro Shams (Beige)",
      desc: "Decorative neutral pillow covers",
      link: "https://amzn.to/4xizKnD",
      qty: 1,
    },
    {
      name: "Lumbar Accent Pillow (Olive Green)",
      desc: "Long decorative accent pillow",
      link: "https://amzn.to/4xeDvdw",
      qty: 1,
    },
    {
      name: "Blanket (Beige)",
      desc: "Cozy throw blanket",
      link: "https://a.co/d/06rjTrXx",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Bedside drawer table",
      link: "https://amzn.to/4wwjkYF",
      qty: 1,
    },
    {
      name: "Lamp Set",
      desc: "Pair of nightstand touch lamps",
      link: "https://a.co/d/0bd30DjJ",
      qty: 1,
    },
    {
      name: "Art Work",
      desc: "Framed wall artwork set",
      link: "https://amzn.to/4hgsiVr",
      qty: 1,
    },
    {
      name: "Samsung 50-inch Smart TV",
      desc: "UHD TV for guest bedroom entertainment",
      link: "https://amzn.to/4pV6vVq",
      qty: 1,
    },
    {
      name: "TV Mount Bracket",
      desc: "Full motion TV mount bracket",
      link: "https://amzn.to/4hchY0v",
      qty: 1,
    },
    {
      name: "6FT Faux Olive Tree",
      desc: "Decorative tall artificial tree",
      link: "https://amzn.to/4fOdlY6",
      qty: 1,
    },
    {
      name: "Bed Bench (White)",
      desc: "White upholstered end-of-bed bench",
      link: "https://amzn.to/4fBXgWE",
      qty: 1,
    },
    {
      name: "9x12 Area Rug",
      desc: "Soft floor area rug under bed",
      link: "https://a.co/d/0aBecZYJ",
      qty: 1,
    },
  ],
  bedroom3: [
    {
      name: "King Size Bed Frame",
      desc: "Upholstered platform bed frame",
      link: "https://amzn.to/3SdFMqF",
      qty: 1,
    },
    {
      name: "King Mattress",
      desc: "Pressure-relieving supportive hybrid mattress",
      link: "https://amzn.to/4w3kYA4",
      qty: 1,
    },
    {
      name: "King Comforter",
      desc: "All-season plush bed insert",
      link: "https://amzn.to/4xh7WA3",
      qty: 1,
    },
    {
      name: "King Comforter Cover",
      desc: "Washable luxury duvet cover",
      link: "https://amzn.to/4wBmnyL",
      qty: 3,
    },
    {
      name: "Flat Sheet (King)",
      desc: "Breathable soft hotel sheet",
      link: "https://amzn.to/3RKKpZa",
      qty: 1,
    },
    {
      name: "Fitted Sheet (King)",
      desc: "Deep pocket mattress fitted sheet",
      link: "https://amzn.to/4fMLh7E",
      qty: 1,
    },
    {
      name: "Mattress Protector",
      desc: "Spill & stain protection cover",
      link: "https://amzn.to/3TSFxSi",
      qty: 1,
    },
    {
      name: "Pillow (King)",
      desc: "Ergonomic hotel bed sleeping pillows",
      link: "https://amzn.to/4fPSpjF",
      qty: 1,
    },
    {
      name: "Euro Shams (Beige)",
      desc: "Decorative neutral pillow covers",
      link: "https://amzn.to/3RRfFFI",
      qty: 1,
    },
    {
      name: "Lumbar Accent Pillow (Blue)",
      desc: "Long blue decorative accent pillow",
      link: "https://amzn.to/4fEh8ag",
      qty: 1,
    },
    {
      name: "Blanket (Blue)",
      desc: "Blue knit throw blanket",
      link: "https://amzn.to/4w2AwUA",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Bedside drawer table",
      link: "https://amzn.to/4wwjkYF",
      qty: 1,
    },
    {
      name: "Lamp Set",
      desc: "Pair of nightstand touch lamps",
      link: "https://a.co/d/0bd30DjJ",
      qty: 1,
    },
    {
      name: "Art Work",
      desc: "Framed wall artwork set",
      link: "https://amzn.to/4hgsiVr",
      qty: 1,
    },
    {
      name: "Samsung 50-inch Smart TV",
      desc: "UHD TV for guest bedroom entertainment",
      link: "https://amzn.to/4pV6vVq",
      qty: 1,
    },
    {
      name: "TV Mount Bracket",
      desc: "Full motion TV mount bracket",
      link: "https://amzn.to/4hchY0v",
      qty: 1,
    },
    {
      name: "6FT Faux Olive Tree",
      desc: "Decorative tall artificial tree",
      link: "https://amzn.to/4fOdlY6",
      qty: 1,
    },
    {
      name: "Bed Bench (Blue)",
      desc: "Blue upholstered end-of-bed bench",
      link: "https://amzn.to/3U8aa6k",
      qty: 1,
    },
    {
      name: "9x12 Area Rug",
      desc: "Soft floor area rug under bed",
      link: "https://a.co/d/0aBecZYJ",
      qty: 1,
    },
  ],
  bedroom4: [
    {
      name: "Twin Size Bed Frame (Beige)",
      desc: "Beige upholstered twin bed frames",
      link: "https://amzn.to/4yUw90G",
      qty: 2,
    },
    {
      name: "Twin Mattress",
      desc: "Comfortable twin size memory foam mattresses",
      link: "https://a.co/d/0cEjqvgb",
      qty: 2,
    },
    {
      name: "Twin Comforter",
      desc: "All-season twin comforters",
      link: "https://amzn.to/4pOFIKg",
      qty: 4,
    },
    {
      name: "Twin Comforter Cover",
      desc: "Soft twin duvet comforter covers",
      link: "https://amzn.to/4zcq5AX",
      qty: 4,
    },
    {
      name: "Flat Sheet (Twin)",
      desc: "Soft flat sheet for twin beds",
      link: "https://amzn.to/4xbFZcH",
      qty: 1,
    },
    {
      name: "Fitted Sheet (Twin)",
      desc: "Deep pocket fitted sheet for twin beds",
      link: "https://a.co/d/0guuA8BF",
      qty: 1,
    },
    {
      name: "Mattress Protector",
      desc: "Waterproof twin mattress protectors",
      link: "https://amzn.to/4xeRyzZ",
      qty: 2,
    },
    {
      name: "Pillow (Twin)",
      desc: "Plush sleeping pillows for twin beds",
      link: "https://amzn.to/4pQHVF4",
      qty: 1,
    },
    {
      name: "Euro Shams (Olive Green)",
      desc: "Decorative olive green euro shams",
      link: "https://amzn.to/3ROPOyd",
      qty: 1,
    },
    {
      name: "Blanket (Olive Green)",
      desc: "Olive green throw blanket",
      link: "https://a.co/d/01pU7cPo",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Nightstand end table",
      link: "https://a.co/d/0gPlMLQb",
      qty: 1,
    },
    {
      name: "Lamp",
      desc: "Bedside reading lamp",
      link: "https://a.co/d/0huoDjaZ",
      qty: 1,
    },
    {
      name: "Samsung 50-inch Smart TV",
      desc: "UHD TV for bedroom entertainment",
      link: "https://amzn.to/4pV6vVq",
      qty: 1,
    },
    {
      name: "TV Mount Bracket",
      desc: "Full motion TV mount bracket",
      link: "https://amzn.to/4hchY0v",
      qty: 1,
    },
    {
      name: "6FT Faux Olive Tree",
      desc: "Decorative tall artificial tree",
      link: "https://amzn.to/4fOdlY6",
      qty: 1,
    },
  ],
  bedroom5: [
    {
      name: "Twin Size Bed Frame (Coffee)",
      desc: "Coffee brown upholstered twin bed frames",
      link: "https://amzn.to/4hQi7qy",
      qty: 2,
    },
    {
      name: "Twin Mattress",
      desc: "Comfortable twin size memory foam mattresses",
      link: "https://a.co/d/0cEjqvgb",
      qty: 2,
    },
    {
      name: "Twin Comforter",
      desc: "All-season twin comforters",
      link: "https://amzn.to/4pOFIKg",
      qty: 4,
    },
    {
      name: "Twin Comforter Cover",
      desc: "Soft twin duvet comforter covers",
      link: "https://amzn.to/4zcq5AX",
      qty: 4,
    },
    {
      name: "Flat Sheet (Twin)",
      desc: "Soft flat sheet for twin beds",
      link: "https://amzn.to/4xbFZcH",
      qty: 1,
    },
    {
      name: "Fitted Sheet (Twin)",
      desc: "Deep pocket fitted sheet for twin beds",
      link: "https://a.co/d/0guuA8BF",
      qty: 1,
    },
    {
      name: "Mattress Protector",
      desc: "Waterproof twin mattress protectors",
      link: "https://amzn.to/4xeRyzZ",
      qty: 2,
    },
    {
      name: "Pillow (Twin)",
      desc: "Plush sleeping pillows for twin beds",
      link: "https://amzn.to/4pQHVF4",
      qty: 1,
    },
    {
      name: "Euro Shams (Olive Green)",
      desc: "Decorative olive green euro shams",
      link: "https://amzn.to/3ROPOyd",
      qty: 1,
    },
    {
      name: "Blanket (Olive Green)",
      desc: "Olive green throw blanket",
      link: "https://a.co/d/01pU7cPo",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Nightstand end table",
      link: "https://a.co/d/0gPlMLQb",
      qty: 1,
    },
    {
      name: "Lamp",
      desc: "Bedside reading lamp",
      link: "https://a.co/d/0huoDjaZ",
      qty: 1,
    },
    {
      name: "Samsung 50-inch Smart TV",
      desc: "UHD TV for bedroom entertainment",
      link: "https://amzn.to/4pV6vVq",
      qty: 1,
    },
    {
      name: "TV Mount Bracket",
      desc: "Full motion TV mount bracket",
      link: "https://amzn.to/4hchY0v",
      qty: 1,
    },
    {
      name: "6FT Faux Olive Tree",
      desc: "Decorative tall artificial tree",
      link: "https://amzn.to/4fOdlY6",
      qty: 1,
    },
  ],
  bedroom6: [
    {
      name: "King Size Bed Frame",
      desc: "Upholstered platform bed frame",
      link: "https://amzn.to/3SdFMqF",
      qty: 1,
    },
    {
      name: "King Mattress",
      desc: "Pressure-relieving supportive hybrid mattress",
      link: "https://amzn.to/4w3kYA4",
      qty: 1,
    },
    {
      name: "King Comforter",
      desc: "All-season plush bed insert",
      link: "https://amzn.to/4xh7WA3",
      qty: 1,
    },
    {
      name: "King Comforter Cover",
      desc: "Washable luxury duvet cover",
      link: "https://amzn.to/4wBmnyL",
      qty: 3,
    },
    {
      name: "Flat Sheet (King)",
      desc: "Breathable soft hotel sheet",
      link: "https://amzn.to/3RKKpZa",
      qty: 1,
    },
    {
      name: "Fitted Sheet (King)",
      desc: "Deep pocket mattress fitted sheet",
      link: "https://amzn.to/4fMLh7E",
      qty: 1,
    },
    {
      name: "Mattress Protector",
      desc: "Spill & stain protection cover",
      link: "https://amzn.to/3TSFxSi",
      qty: 1,
    },
    {
      name: "Pillow (King)",
      desc: "Ergonomic hotel bed sleeping pillows",
      link: "https://amzn.to/4fPSpjF",
      qty: 1,
    },
    {
      name: "Euro Shams (Beige)",
      desc: "Decorative neutral pillow covers",
      link: "https://amzn.to/4xizKnD",
      qty: 1,
    },
    {
      name: "Lumbar Accent Pillow (Olive Green)",
      desc: "Long decorative accent pillow",
      link: "https://amzn.to/4xeDvdw",
      qty: 1,
    },
    {
      name: "Blanket (Beige)",
      desc: "Cozy throw blanket",
      link: "https://a.co/d/06rjTrXx",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Bedside drawer table",
      link: "https://amzn.to/4wwjkYF",
      qty: 1,
    },
    {
      name: "Lamp Set",
      desc: "Pair of nightstand touch lamps",
      link: "https://a.co/d/0bd30DjJ",
      qty: 1,
    },
    {
      name: "Art Work",
      desc: "Framed wall artwork set",
      link: "https://amzn.to/4hgsiVr",
      qty: 1,
    },
    {
      name: "Samsung 50-inch Smart TV",
      desc: "UHD TV for guest bedroom entertainment",
      link: "https://amzn.to/4pV6vVq",
      qty: 1,
    },
    {
      name: "TV Mount Bracket",
      desc: "Full motion TV mount bracket",
      link: "https://amzn.to/4hchY0v",
      qty: 1,
    },
    {
      name: "6FT Faux Olive Tree",
      desc: "Decorative tall artificial tree",
      link: "https://amzn.to/4fOdlY6",
      qty: 1,
    },
    {
      name: "Bed Bench (White)",
      desc: "White upholstered end-of-bed bench",
      link: "https://amzn.to/4fBXgWE",
      qty: 1,
    },
    {
      name: "9x12 Area Rug",
      desc: "Soft floor area rug under bed",
      link: "https://a.co/d/0aBecZYJ",
      qty: 1,
    },
  ],
  mainFloorBedroom: [
    {
      name: "King Size Bed Frame",
      desc: "Upholstered platform bed frame",
      link: "https://amzn.to/3SdFMqF",
      qty: 1,
    },
    {
      name: "King Mattress",
      desc: "Pressure-relieving supportive hybrid mattress",
      link: "https://amzn.to/4w3kYA4",
      qty: 1,
    },
    {
      name: "King Comforter",
      desc: "All-season plush bed insert",
      link: "https://amzn.to/4xh7WA3",
      qty: 1,
    },
    {
      name: "King Comforter Cover",
      desc: "Washable luxury duvet cover",
      link: "https://amzn.to/4wBmnyL",
      qty: 3,
    },
    {
      name: "Flat Sheet (King)",
      desc: "Breathable soft hotel sheet",
      link: "https://amzn.to/3RKKpZa",
      qty: 1,
    },
    {
      name: "Fitted Sheet (King)",
      desc: "Deep pocket mattress fitted sheet",
      link: "https://amzn.to/4fMLh7E",
      qty: 1,
    },
    {
      name: "Mattress Protector",
      desc: "Spill & stain protection cover",
      link: "https://amzn.to/3TSFxSi",
      qty: 1,
    },
    {
      name: "Pillow (King)",
      desc: "Ergonomic hotel bed sleeping pillows",
      link: "https://amzn.to/4fPSpjF",
      qty: 1,
    },
    {
      name: "Euro Shams (Beige)",
      desc: "Decorative neutral pillow covers",
      link: "https://amzn.to/4xizKnD",
      qty: 1,
    },
    {
      name: "Lumbar Accent Pillow (Olive Green)",
      desc: "Long decorative accent pillow",
      link: "https://amzn.to/4xeDvdw",
      qty: 1,
    },
    {
      name: "Blanket (Beige)",
      desc: "Cozy throw blanket",
      link: "https://a.co/d/06rjTrXx",
      qty: 1,
    },
    {
      name: "End Table",
      desc: "Bedside drawer table",
      link: "https://amzn.to/4wwjkYF",
      qty: 1,
    },
    {
      name: "Lamp Set",
      desc: "Pair of nightstand touch lamps",
      link: "https://a.co/d/0bd30DjJ",
      qty: 1,
    },
    {
      name: "Art Work",
      desc: "Framed wall artwork set",
      link: "https://amzn.to/4hgsiVr",
      qty: 1,
    },
    {
      name: "Samsung 50-inch Smart TV",
      desc: "UHD TV for guest bedroom entertainment",
      link: "https://amzn.to/4pV6vVq",
      qty: 1,
    },
    {
      name: "TV Mount Bracket",
      desc: "Full motion TV mount bracket",
      link: "https://amzn.to/4hchY0v",
      qty: 1,
    },
    {
      name: "6FT Faux Olive Tree",
      desc: "Decorative tall artificial tree",
      link: "https://amzn.to/4fOdlY6",
      qty: 1,
    },
    {
      name: "Bed Bench (White)",
      desc: "White upholstered end-of-bed bench",
      link: "https://amzn.to/4fBXgWE",
      qty: 1,
    },
    {
      name: "9x12 Area Rug",
      desc: "Soft floor area rug under bed",
      link: "https://a.co/d/0aBecZYJ",
      qty: 1,
    },
  ],
  bathroom: [
    {
      name: "6-Piece Bathroom Accessory Set",
      desc: "Matching soap dispenser, tumbler & trash bin",
      link: "https://amzn.to/4vURqVE",
      qty: 1,
    },
    {
      name: "Guest Shampoo & Conditioner Set",
      desc: "Hotel-quality bath toiletries",
      link: "https://amzn.to/4vjjNwV",
      qty: 1,
    },
    {
      name: "Guest Body Wash",
      desc: "Hydrating body wash bottles",
      link: "https://amzn.to/4ehQlkY",
      qty: 1,
    },
    {
      name: "Toilet Paper Holder",
      desc: "Freestanding TP dispenser stand",
      link: "https://amzn.to/4vjslUw",
      qty: 1,
    },
    {
      name: "Toilet Plunger & Bowl Brush Set",
      desc: "Sanitary bathroom cleaning combo",
      link: "https://amzn.to/4a9HHm2",
      qty: 1,
    },
    {
      name: "Liquid Hand Soap Pump",
      desc: "Moisturizing hand soap dispenser",
      link: "https://amzn.to/4eklSRK",
      qty: 1,
    },
    {
      name: "Plush Bath Towels Set",
      desc: "Soft cotton bath towel pack",
      link: "https://amzn.to/3Sdw2wg",
      qty: 1,
    },
  ],
  basement: [
    {
      name: "Foosball Table",
      desc: "Game room arcade foosball table",
      link: "https://amzn.to/4wDTuSF",
      qty: 1,
    },
    {
      name: "Poker Table",
      desc: "8-player casino game table with cup holders",
      link: "https://amzn.to/45E6Br7",
      qty: 1,
    },
    {
      name: "Foldable Chairs (x12)",
      desc: "Extra seating for game room & events",
      link: "https://amzn.to/4gb3pJx",
      qty: 1,
    },
    {
      name: "85 Inches TV",
      desc: "Large basement theater TV screen",
      link: "https://amzn.to/4bomLbC",
      qty: 1,
    },
    {
      name: "TV Mount",
      desc: 'Heavy-duty wall bracket for 85" TV',
      link: "https://amzn.to/4bNWMdV",
      qty: 1,
    },
    {
      name: "Olive Tree (7FT)",
      desc: "Tall corner greenery for basement lounge",
      link: "https://amzn.to/3UbWyHb",
      qty: 1,
    },
    {
      name: "Rug (9x12)",
      desc: "Cozy floor rug for game room area",
      link: "https://amzn.to/4w5svhG",
      qty: 1,
    },
    {
      name: "Massage Chair",
      desc: "Full body reclining massage chair",
      link: "https://amzn.to/4w6RVM2",
      qty: 1,
    },
  ],
};

export type FurnitureItem = {
  name: string;
  desc: string;
  link: string;
  qty: number;
};
